import { render, staticRenderFns } from "./AiTextSuggestDialog.vue?vue&type=template&id=854348d0&scoped=true"
import script from "./AiTextSuggestDialog.vue?vue&type=script&lang=js"
export * from "./AiTextSuggestDialog.vue?vue&type=script&lang=js"
import style0 from "./AiTextSuggestDialog.vue?vue&type=style&index=0&id=854348d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854348d0",
  null
  
)

export default component.exports